<!-- 商品供应商-侧边菜单 -->
<template>
  <div :class="['side-bar-menu', { close: !open }]">
    <span
      :class="[
        'menu-toggle-button mtdicon mtdicon-left-thick',
        { close: !open },
      ]"
      @click="toggleFold"
    ></span>

    <div :class="['menu-container', { close: !open }]">
      <mtd-menu
        v-model="activeMenu"
        mode="inline"
        accordion
        :default-expanded-names="defaultExpandedMenuNames"
        @select="handleSelectMenu"
      >
        <template v-for="item in sourceData">
          <template v-if="firstLevelMenuShow(item)">
            <mtd-submenu
              v-if="item.children && item.children.length"
              :key="item.id + '-sub'"
              :name="item.id"
              :class="['custom-sub-menu']"
            >
              <template #icon>
                <mtd-icon :name="item.icon"></mtd-icon>
              </template>
              <template #title>
                <div class="first-level-title">{{ item.text }}</div>
              </template>
              <template v-for="(childItem, childIndex) in item.children">
                <mtd-menu-item
                  v-if="subMenuShow(childItem)"
                  :key="childIndex"
                  :name="childItem.id"
                >
                  <span
                    :class="[
                      'second-level-menu-title',
                      isCurrentMenuItem(childItem) ? 'active-title' : '',
                    ]"
                  >
                    {{ childItem.text }}
                  </span>
                </mtd-menu-item>
              </template>
            </mtd-submenu>

            <mtd-menu-item v-else :key="item.id + '-item'" :name="item.id">
              <template #icon>
                <mtd-icon :name="item.icon"></mtd-icon>
              </template>
              <span
                :class="[
                  'first-level-menu-title',
                  isCurrentMenuItem(item) ? 'active-title' : '',
                ]"
              >
                {{ item.text }}
              </span>
            </mtd-menu-item>
          </template>
        </template>
      </mtd-menu>
    </div>
  </div>
</template>

<script>
import { hPost, cloneDeep } from "@osgfe/tools";
import { setStorageWithoutRegion } from "@osgfe/tools-storage";

export default {
  name: "RenxiaoAsideMenu",
  inject: ['$xxMenu'],
  data() {
    return {
      activeMenu: "",
      // 定义响应式数据-当前路由，用于触发更新
      currentPath: window.location.pathname,
      // 有权限的菜单项
      authorizedMenuData: [],
      sourceData: [],
      showMenu: false,
      open: true,
    };
  },
  computed: {
    originMenuData() {
      return (this.$xxMenu.menuData || []).map((item) => {
        const { text, i18nKey } = item;
        item.text = this.getTranslatedText(i18nKey, { defaultValue: text });
        if (item.children && item.children.length) {
          item.children = item.children.map((v) => ({
            ...v,
            text: this.getTranslatedText(v.i18nKey, { defaultValue: v.text }),
          }))
        }
        return item;
      });
    },
    defaultExpandedMenuNames() {
      const expandedMenuNames = [];
      this.sourceData.forEach((menuItem) => {
        if((menuItem.children || []).map((v) => v.id).includes(this.activeMenu)) {
          expandedMenuNames.push(menuItem.id);
        }
      });
      return expandedMenuNames;
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.getAuthorizedMenu();
    });
  },
  methods: {
    getTranslatedText(key, options = {}) {
      const res = this.$getText(key, options);
      return res;
    },

    toggleFold() {
      this.open = !this.open;
      setStorageWithoutRegion("openSidebar", this.open);
      this.$emit("toggleEvent", this.open);
    },

    firstLevelMenuShow(menuItem) {
      /**
       * 一级菜单是否展示：先看visible, 再看子菜单是否有至少有一个有权限，再看它自己有没有权限是不是一个链接。
       */
      if (!menuItem.visible) {
        return false;
      }

      // 它自身有 url 且有权限的话，它就可见。
      return menuItem.text && menuItem.url;
    },

    // 判断是否为当前选中菜单项
    isCurrentMenuItem(item) {
      const path = this.currentPath;
      if (path === item.url) {
        this.activeMenu = item.id;
        return true;
      }

      // 因为访问/和/index.html都是首页，这里做个兼容
      if (
        (path === "/" || path === "/index") &&
        (item.url === "/" || item.url === "/index")
      ) {
        this.activeMenu = item.id;
        return true;
      }

      return false;
    },

    // 根据账号角色信息过滤菜单——仅展示有权限的菜单项
    async getAuthorizedMenu() {
      // 获取登录账号信息
      const res = await hPost("/api/emp-vss/supplier/admin/login_account", {});

      const { roleType } = res || {};

      // 过滤掉无权限的菜单项
      this.authorizedMenuData = (cloneDeep(this.originMenuData) || []).filter(
        (item) => {
          const { roles = [] } = item;
          // roles为[]或无roles时, 表示菜单无权限控制, 否则需验证roleType
          const hasPermission = !roles.length || roles.includes(roleType);
          return hasPermission;
        }
      );

      await this.loadMenuFromAuth();
    },

    subMenuShow(subMenuItem) {
      return subMenuItem.visible && subMenuItem.url;
    },

    loadMenuFromAuth() {
      const menuData = cloneDeep(this.authorizedMenuData) || [];
      this.sourceData = menuData;
      this.showMenu = true;
    },

    findItemByProp(nestedMenuList, prop, target) {
      for (const item of nestedMenuList) {
        if (item[prop] === target) {
          return item;
        }
        const indexPath = ["/", "/index"];
        if (
          prop === "url" &&
          indexPath.includes(target) &&
          indexPath.includes(item[prop])
        ) {
          return item;
        }
        if (item.children && item.children.length > 0) {
          const found = this.findItemByProp(item.children, prop, target);
          if (found) {
            return found;
          }
        }
      }
      return null;
    },

    handleSelectMenu(item) {
      const menu = this.findItemByProp(this.sourceData, "id", item.name);
      if (menu) {
        this.activeMenu = menu.id;
        this.currentPath = menu.url;
        this.$xxMenu.linkTo(menu);
      }
    },
  },
};
</script>

<style scoped>
.first-level-menu-title {
  font-weight: 500;
  color: #191919;
}

.second-level-menu-title {
  font-size: 14px;
  line-height: 22px;
  color: #111925;
}

.active-title {
  color: #01a65c;
}

.custom-sub-menu {
  margin-block-start: 16px;
}

:deep() .mtd-menu-item-active .mtd-submenu-icon {
  color: #00b85c;
}

:deep() .mtd-submenu-expanded .mtd-submenu-icon {
  color: #00b85c;
}

:deep() .mtd-submenu-expanded .first-level-title {
  color: #01a65c;
}

:deep() .mtd-submenu ul.mtd-submenu-content {
  margin-block-start: 8px;
}

:deep() .mtd-submenu ul.mtd-submenu-content li:not(:last-child) {
  margin-block-end: 16px;
}

:deep() .mtd-submenu .mtd-menu-item-text {
  background: #fff;
  padding: 8px;
  line-height: 22px;
  border-radius: 8px;
}

:deep() .mtd-submenu .mtd-menu-item-active .mtd-menu-item-text {
  background: #e5f7ee;
}

:deep() .mtd-menu-item-active:before {
  background: #fff !important;
}

:deep() .mtd-menu-item-title {
  background: #fff !important;
}

:deep() .mtd-menu {
  line-height: 48px;
}

:deep() .mtd-submenu-title:hover .mtd-submenu-direction {
  color: #00b85c !important;
}

.menu-dot-num {
  position: absolute;
  top: -4px;
  right: 0px;
  background-color: red;
  border-radius: 99px;
  color: #fff;
  font-size: 12px;
  transform: scale(0.8);
  min-width: 20px;
  height: 20px;
  text-align: center;
  line-height: 20px;
  font-weight: bold;
  padding: 0px 2px;
}
.side-bar-menu {
  width: 316px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #fff;
  transition: all 0.2s;
  position: relative;
  z-index: 2;
}
.side-bar-menu.close {
  width: 20px;
}

.menu-container {
  overflow: auto;
  padding: 12px 0 0 0;
  transition: all 0.2s;
}
.menu-container.close {
  transform: translateX(-180px);
  opacity: 0;
}

.list-box {
  padding: 0 0 60px 0;
}

.side-bar-menu-list {
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
}
.side-bar-menu-bottom {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  z-index: 1;
  /* height: 40px; */
  line-height: 20px;
  color: rgba(255, 255, 255, 0.95);
  background: rgba(255, 255, 255, 0.03);
  box-shadow: rgba(0, 0, 0, 0.917647) 0 21px 20px 0,
    rgba(0, 0, 0, 0.3157) 0 0 15px 0;
}
.side-bar-menu-bottom .side-bar-fold {
  display: flex;
  width: 40px;
  /* height: 40px; */
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.side-bar-menu-bottom .side-bar-fold.close {
  width: 50px;
}

.menu-toggle-button {
  position: absolute;
  top: 24px;
  right: -10px;
  width: 24px;
  height: 24px;
  background-color: #fff;
  box-shadow: 0 1px 3px 0 rgba(17, 25, 37, 0.1);
  cursor: pointer;
  text-align: center;
  line-height: 24px;
  border-radius: 99px;
  z-index: 999;
  transition: all 0.2s;
}

:root[dir="rtl"] .menu-toggle-button {
  left: -10px;
  right: auto;
}

.menu-toggle-button:hover {
  transform: scale(1.1);
}
.menu-toggle-button.close {
  transform: rotate(180deg);
}

:root[dir="rtl"] .menu-toggle-button.close {
  transform: rotate(360deg);
}
:root[dir="rtl"] .menu-toggle-button {
  transform: rotate(180deg);
}

:root[dir="rtl"] .menu-container :deep(.mtd-menu-item-text) {
  text-align: right !important;
}
:root[dir="rtl"] .menu-container :deep(.mtd-submenu-text) {
  text-align: right !important;
}

:root[dir="rtl"] .menu-container :deep(.mtd-submenu-icon) {
  margin-right: 0;
  margin-left: 8px !important;
}

:root[dir="rtl"] .menu-container :deep(.mtd-menu-item-icon) {
  margin-right: 0;
  margin-left: 8px !important;
}

:root[dir="rtl"] .menu-container :deep(.mtd-submenu-direction) {
  margin-left: 0;
  margin-right: 12px;
}

.menu-box {
  padding: 0px 16px 20px 16px;
}
.menu-parent,
.solo-menu-link {
  font-size: 18px;
  color: #191919;
  line-height: 26px;
  font-weight: 500;
  padding: 0 0 0 5px;
  text-decoration: none;
}
.solo-menu-link:hover {
  cursor: pointer;
}
.solo-menu-link.current {
  color: #01a65c;
}
.menu-parent:has(+ .menu-item-container .current) {
  color: #01a65c;
}
.menu-item-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 14px 0 0 0;
  position: relative;
}
.aside-menu-icon {
  margin-right: 5px;
}
.menu-item {
  color: #666666;
  text-decoration: none;
  width: 50%;
  margin-bottom: 6px;
  font-size: 14px;
  padding: 4px 4px 4px 7px;
  border-radius: 4px;
  position: relative;
}

.menu-item:hover {
  color: #666666;
  background-color: #f8f8f8;
  cursor: pointer;
}

.menu-item.current {
  background: #e5f7ee;
  color: #00b85c;
  font-weight: 600;
}

.menu-item .full-text {
  display: none;
}

.menu-item:hover .full-text {
  display: block;
}
.menu-text {
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
  overflow: hidden;
}
.full-text {
  display: none;
  position: absolute;
  top: -33px;
  right: 0px;
  padding: 6px 10px;
  background: #292929;
  color: #fff;
  font-size: 12px;
  border-radius: 4px;
  white-space: nowrap;
}
.full-text::before {
  content: "";
  position: absolute;
  bottom: -5px;
  left: 50px;
  border-top: 5px solid #292929;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 0px;
}
::-webkit-scrollbar {
  width: 4px;
}
::-webkit-scrollbar-track {
  background-color: transparent;
}
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: #dcdddf;
}
</style>